(() => {
  if (customElements.get('scent-option-feedback')) return;
  const palettes = {
    pineforest: '#e8ede3', lavendergarden: '#eee8f4', lemonsherbet: '#fff4cc',
    rosefloral: '#f5e5e8', freshcitrus: '#fbe9d6',
    '파인포레스트': '#e8ede3', '라벤더가든': '#eee8f4', '레몬셔벗': '#fff4cc',
    '로즈플로럴': '#f5e5e8', '프레시시트러스': '#fbe9d6',
    starlight: '#f5f1e7', silver: '#f5f1e7', '스타라이트': '#f5f1e7', '실버': '#f5f1e7',
    paleblue: '#e5eef2', pearblue: '#e5eef2', '페일블루': '#e5eef2',
    woodorange: '#f5e2d1', '우드오렌지': '#f5e2d1'
  };
  const normalize = (value) => value.toLowerCase().replace(/[\s_-]+/g, '');
  customElements.define('scent-option-feedback', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info[data-scent-options]');
      this.picker = this.closest('variant-selects');
      if (!this.root || !this.picker) { this.hidden = true; return; }
      this.onChange = () => this.update();
      this.picker.addEventListener('change', this.onChange);
      // Also runs after Shopify replaces the picker with its server response.
      queueMicrotask(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() {
      this.picker?.removeEventListener('change', this.onChange);
    }
    update() {
      const selected = [...this.picker.querySelectorAll('input[type="radio"]:checked, select')]
        .map(input => {
          const option = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
          return { name: option?.dataset.optionName || input.name, value: input.value };
        });
      const text = selected.map(item => `${item.name}: ${item.value}`).join(' · ');
      const output = this.querySelector('[data-scent-selection-text]');
      if (output && output.textContent !== text) output.textContent = text;
      const color = selected.find(item => /^(scent|fragrance|향|향기|color|colour|색상|색)$/i.test(item.name.trim())) ||
        selected.find(item => palettes[normalize(item.value)]);
      this.root.style.setProperty('--scent-option-background', palettes[normalize(color?.value || '')] || '#f5f1e7');
    }
  });
})();
